// extracted by mini-css-extract-plugin
export default {"card":"HorizontalCard_card__bC1K6","background":"HorizontalCard_background__iwXHh"};